export const SUCCESS_PROPERTY_TYPE="SUCCESS_PROPERTY_TYPE";
export const FAILED_PROPERTY_TYPE="FAILED_PROPERTY_TYPE";
export const REQUST_PROPERTY_TYPE="REQUST_PROPERTY_TYPE";
